var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4948 13.0646C19.1413 12.6404 18.5107 12.583 18.0864 12.9366C17.6621 13.2902 17.6048 13.9207 17.9584 14.345L19.4948 13.0646ZM24.2509 20.334L25.0191 20.9742C25.3282 20.6033 25.3282 20.0647 25.0191 19.6938L24.2509 20.334ZM17.9584 26.323C17.6048 26.7473 17.6621 27.3778 18.0864 27.7314C18.5107 28.085 19.1413 28.0276 19.4948 27.6034L17.9584 26.323ZM17.9584 14.345L23.4827 20.9742L25.0191 19.6938L19.4948 13.0646L17.9584 14.345ZM23.4827 19.6938L17.9584 26.323L19.4948 27.6034L25.0191 20.9742L23.4827 19.6938ZM20.5 34C12.768 34 6.5 27.732 6.5 20L4.5 20C4.5 28.8366 11.6634 36 20.5 36L20.5 34ZM6.5 20C6.5 12.268 12.768 6 20.5 6L20.5 4C11.6634 4 4.5 11.1634 4.5 20L6.5 20ZM20.5 6C28.232 6 34.5 12.268 34.5 20L36.5 20C36.5 11.1634 29.3366 4 20.5 4L20.5 6ZM34.5 20C34.5 27.732 28.232 34 20.5 34L20.5 36C29.3366 36 36.5 28.8366 36.5 20L34.5 20Z",
    fill: "#302F2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight);
export default __webpack_public_path__ + "static/media/right.42b11187b5996aaf0df90c26abc5505d.svg";
export { ForwardRef as ReactComponent };